import { Controller } from "stimulus";
import { destroy } from "@rails/request.js";

// "Emitidos" segment of the files tab: lists system-generated documents. Search,
// row preview (delegated to the shared file-preview controller via event) and a
// context menu with the real actions (Visualizar / Baixar / Editar / Excluir).
export default class extends Controller {
  static targets = ["search", "item"];

  connect() {
    this.onDocumentClickHandler = (event) => { if (!event.target.closest(".fm-ctx")) this.closeMenu(); };
    this.onKeydownHandler = (event) => { if (event.key === "Escape") this.closeMenu(); };
    document.addEventListener("click", this.onDocumentClickHandler);
    document.addEventListener("keydown", this.onKeydownHandler);
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClickHandler);
    document.removeEventListener("keydown", this.onKeydownHandler);
    this.closeMenu();
  }

  // ---------- search ----------
  search() {
    const query = (this.searchTarget.value || "").toLowerCase().trim();
    this.itemTargets.forEach((item) => {
      const name = `${item.dataset.fileName || ""} ${item.dataset.docTemplate || ""}`.toLowerCase();
      item.style.display = !query || name.includes(query) ? "" : "none";
    });
  }

  // ---------- open / preview ----------
  open(event) {
    if (event.target.closest('[data-issued-documents-target~="menuButton"]')) return;
    this.preview(event.currentTarget);
  }

  preview(item) {
    document.dispatchEvent(new CustomEvent("file-preview:open", { detail: { ...item.dataset } }));
  }

  // ---------- context menu ----------
  openMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    const item = event.target.closest("[data-doc-id]");
    if (!item) return;
    this.closeMenu();

    const menu = document.createElement("div");
    menu.className = "fm-ctx fixed z-[80] min-w-[190px] p-1 rounded-[10px] bg-white shadow-[0_1px_2px_rgba(26,24,22,0.06),0_6px_24px_-8px_rgba(26,24,22,0.10)] border border-[rgba(26,24,22,0.14)]";
    menu.innerHTML = this.menuHtml(item);
    document.body.appendChild(menu);
    this.menuElement = menu;
    this.bindMenuActions(menu, item);

    const anchorX = event.clientX || item.getBoundingClientRect().right;
    const anchorY = event.clientY || item.getBoundingClientRect().bottom;
    menu.style.left = Math.min(anchorX, window.innerWidth - menu.offsetWidth - 8) + "px";
    menu.style.top = Math.min(anchorY, window.innerHeight - menu.offsetHeight - 8) + "px";
  }

  closeMenu() { if (this.menuElement) { this.menuElement.remove(); this.menuElement = null; } }

  menuItem(action, label, danger = false) {
    const textColor = danger ? "color:var(--fm-accent,#c85a3e)" : "color:#1a1816";
    return `<button type="button" data-act="${action}" class="flex w-full items-center gap-[10px] px-[10px] py-[7px] rounded-md text-[12.5px] text-left hover:bg-[rgba(26,24,22,0.04)]" style="${textColor}">${label}</button>`;
  }

  menuHtml(item) {
    const download = item.dataset.downloadUrl
      ? this.menuItem("download", "Baixar PDF")
      : "";
    return (
      this.menuItem("preview", "Visualizar") +
      download +
      this.menuItem("edit", "Editar") +
      `<div class="h-px bg-[rgba(26,24,22,0.08)] my-1 mx-[6px]"></div>` +
      this.menuItem("delete", "Excluir", true)
    );
  }

  bindMenuActions(menu, item) {
    menu.querySelectorAll("[data-act]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.stopPropagation();
        const action = button.dataset.act;
        this.closeMenu();
        if (action === "preview") this.preview(item);
        else if (action === "download") window.open(item.dataset.downloadUrl, "_blank");
        else if (action === "edit") this.edit(item);
        else if (action === "delete") this.delete(item);
      });
    });
  }

  edit(item) {
    const link = document.createElement("a");
    link.href = item.dataset.editUrl;
    link.dataset.turboFrame = "turbo-modal";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  async delete(item) {
    if (!confirm(`Excluir o documento “${item.dataset.fileName}”?`)) return;
    await destroy(item.dataset.destroyUrl, { responseKind: "turbo-stream" });
  }
}
